import React from "react";
import { useSelector } from "react-redux";
import { Modal } from "antd";

import classes from "./Modal.module.css";
import CommonButton from "../Components/Buttons/CommonButton";
import deleteimg from "../Assests/Icons/whitedelete.png";

interface props {
  handleSuccess: () => void;
  itemName?: String;
  Delete?: boolean;
  open: boolean;
  closable: boolean;
  onCancel: () => void;
}

function DeleteConfirmation({
  handleSuccess,
  itemName,
  Delete = false,
  open,
  closable,
  onCancel,
}: props) {
  const { LoginData } = useSelector((state: any) => state.Auth);

  return (
    <Modal open={open} closable={closable} width={350} footer={null}>
      <div
        style={{
          borderRadius: "19px",
          border: "1px solid red",
          borderTop: "6px solid red",
        }}
      >
        {/* <h4 className={classes.modal_heading}>
          {!Delete ? "Confirmation" : "Delete"}
        </h4> */}
        <div style={{ position: "relative" }}>
          <div
            style={{
              width: "60px",
              height: "60px",
              background: "red",
              borderRadius: "44px",
              position: "absolute",
              right: "41%",
              marginTop: "-42px",
            }}
          >
            <div>
              <img
                src={deleteimg}
                alt="deleteimg"
                style={{ width: "40px", margin: "9px 10px" }}
              />
            </div>
          </div>
        </div>
        {/* <div
          className={`${classes.sessionContentSec} w-100 `}
          style={{ textAlign: "center" }}
        >
          {!Delete && <p className="m-0">Hi user {LoginData?.userName}</p>}
          <p>
            Are you sure you want to {!Delete ? "logout" : "delete"} {itemName}{" "}
            ?
          </p>
        </div> */}
        <div className={classes.modal_container} style={{ paddingBottom: "0" }}>
          <div>
            <h5 style={{ textAlign: "center", marginTop: "9px" }}>
              Delete the <span style={{ color: "#ff4a00" }}>{itemName}</span>?
            </h5>
            <p style={{ textAlign: "center", fontSize: "15px" }}>
              You will not be able to recover it
            </p>
          </div>
        </div>
        <div
          style={{
            background: "#7777771c",
            padding: "10px 0 10px 0px",
            borderRadius: "0px 0px 20px 20px",
          }}
        >
          <div
            className={`${classes.modal_button_container} justify-content-around`}
            style={{ margin: "0" }}
          >
            <CommonButton
              name="Yes"
              onClick={() => handleSuccess()}
              type="button"
              style={{
                padding: "7px 24px",
              }}
              classname="submit_btn"
            />
            <CommonButton
              name="No"
              onClick={() => onCancel()}
              type="No"
              style={{
                padding: "7px 24px",
              }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteConfirmation;
